@new-grey-600: #637381;

.nickname {
  .subtext {
    font-size: 12px;
    color: @new-grey-600;
    margin-top: 8px;
  }

  .nickname-input label {
    font-size: 12px;
    font-weight: 400;
  }
}
